import * as qs from 'qs';

export namespace AxiosPromise {
    const axios = require('axios');
    const jsonp = require('jsonp');
    export async function get(uri: string): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.get(uri)
                .then(function (response: any) {
                    // handle success
                    resolve(response.data);
                })
                .catch(function (error: any) {
                    // handle error
                    reject(error);
                })
                .finally(function () {
                    // always executed
                });
        });
    }

    export async function postForm(uri: string, formData: FormData): Promise<any> {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: uri,
                data: formData,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            })
                .then(function (response: any) {
                    resolve(response);
                })
                .catch(function (response: any) {
                    reject(response);
                });
        });
    }

    export async function postUrlEncode(uri: string, requestParams: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: uri,
                data: qs.stringify(requestParams),
                config: {
                    headers: {
                        'Content-type': 'application/x-www-form-urlencoded'
                    }
                }
            })
                .then(function (response: any) {
                    resolve(response);
                })
                .catch(function (response: any) {
                    reject(response);
                });
        });
    }

    export async function postJson(uri: string, requestBody: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: uri,
                data: requestBody,
                config: {
                    headers: {
                        'Content-type': 'application/json'
                    }
                }
            })
                .then(function (response: any) {
                    resolve(response);
                })
                .catch(function (response: any) {
                    reject(response);
                });
        });
    }

    export async function aJsonp(uri: string) {
        return new Promise((resolve, reject) => {
            jsonp(uri, null, (err: any, data: any) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(data);
                }
            });
        });
    }
}
